import { useMutation } from '@tanstack/react-query';
import useAxios from '../../../app/hooks/useAxios';

const useUserUpdatePassword = () => {
	const { post } = useAxios();

	const userUpdatePassword = (data: { oldPassword: string; newPassword: string }) => {
		return post(`/users/me/password`, data);
	};

	return useMutation(userUpdatePassword);
};

export default useUserUpdatePassword;
